
const Divider = () => {
  return (
    <div className="my-8 flex justify-center">
      <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent w-full max-w-4xl" />
    </div>
  );
};

export default Divider;
